export const filterRecommendationByTagFilterExistsOperator = (
  resourceTagFilterMap: Map<string, string>,
  tagsFilterKey: string,
) => {
  return resourceTagFilterMap.has(tagsFilterKey);
};
